export function times(amount: number) {
  return Array.from(Array(amount).keys());
}

export function filterBoolean<T>(
  x: T | false | undefined | null | '' | 0,
): x is T {
  return !!x;
}
